import { render, staticRenderFns } from "./sms-send-log.vue?vue&type=template&id=71f27068&scoped=true&"
import script from "./sms-send-log.vue?vue&type=script&lang=js&"
export * from "./sms-send-log.vue?vue&type=script&lang=js&"
import style0 from "./sms-send-log.vue?vue&type=style&index=0&id=71f27068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f27068",
  null
  
)

export default component.exports